function required(key: keyof ImportMetaEnv): string {
  const value = import.meta.env[key];
  if (!value) {
    throw new Error(`Missing env var ${String(key)}. See web/.env.example.`);
  }
  return value;
}

export const config = {
  apiUrl: required('VITE_API_URL'),
  cognitoUserPoolId: required('VITE_COGNITO_USER_POOL_ID'),
  cognitoClientId: required('VITE_COGNITO_CLIENT_ID'),
  cognitoDomain: required('VITE_COGNITO_DOMAIN'),
  region: required('VITE_AWS_REGION'),
} as const;
